module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "WevrLogoTextBeta.8ba9d2c8.svg";